import React, { createContext, useEffect, useMemo, useState } from "react";
import { IActionSidebarsContext } from "../types/actionSidebars";

export const ActionSidebarsContext = createContext<null | IActionSidebarsContext>(null);

interface Props {
    children: React.ReactNode
}

// Handle open & close of sidebars
export const ActionSidebarsProvider: React.FC<Props> = ({ children }) => {
    const [sidebarAddServiceOpen, setSidebarAddServiceOpen] = useState(false);
    const [sidebarModifyFleetOpen, setSidebarModifyFleetOpen] = useState(false);
    const [sidebarAddRouteOpen, setSidebarAddRouteOpen] = useState(false);
    const [sidebarNotificationsOpen, setSidebarNotificationsOpen] = useState(false);
    const [sidebarAddDriverOpen, setSidebarAddDriverOpen] = useState(false);
    const [sidebarAddVehicleOpen, setSidebarAddVehicleOpen] = useState(false);
    const [sidebarAddAssociationsOpen, setSidebarAddAssociationsOpen] = useState(false);

    useEffect(() => {
        if (sidebarAddServiceOpen) {
            setSidebarModifyFleetOpen(false);
            setSidebarAddRouteOpen(false);
            setSidebarNotificationsOpen(false);
            setSidebarAddDriverOpen(false);
            setSidebarAddVehicleOpen(false);
            setSidebarAddAssociationsOpen(false);
        }
    }, [sidebarAddServiceOpen]);

    useEffect(() => {
        if (sidebarModifyFleetOpen) {
            setSidebarAddServiceOpen(false);
            setSidebarAddRouteOpen(false);
            setSidebarNotificationsOpen(false);
            setSidebarAddDriverOpen(false);
            setSidebarAddVehicleOpen(false);
            setSidebarAddAssociationsOpen(false);
        }
    }, [sidebarModifyFleetOpen]);

    useEffect(() => {
        if (sidebarAddRouteOpen) {
            setSidebarAddServiceOpen(false);
            setSidebarModifyFleetOpen(false);
            setSidebarNotificationsOpen(false);
            setSidebarAddDriverOpen(false);
            setSidebarAddVehicleOpen(false);
            setSidebarAddAssociationsOpen(false);
        }
    }, [sidebarAddRouteOpen]);

    useEffect(() => {
        if (sidebarNotificationsOpen) {
            setSidebarAddServiceOpen(false);
            setSidebarModifyFleetOpen(false);
            setSidebarAddRouteOpen(false);
            setSidebarAddDriverOpen(false);
            setSidebarAddVehicleOpen(false);
            setSidebarAddAssociationsOpen(false);
        }
    }, [sidebarNotificationsOpen]);

    useEffect(() => {
        if (sidebarAddDriverOpen) {
            setSidebarAddServiceOpen(false);
            setSidebarModifyFleetOpen(false);
            setSidebarAddRouteOpen(false);
            setSidebarNotificationsOpen(false);
            setSidebarAddVehicleOpen(false);
            setSidebarAddAssociationsOpen(false);
        }
    }, [sidebarAddDriverOpen]);

    useEffect(() => {
        if (sidebarAddVehicleOpen) {
            setSidebarAddServiceOpen(false);
            setSidebarModifyFleetOpen(false);
            setSidebarAddRouteOpen(false);
            setSidebarNotificationsOpen(false);
            setSidebarAddDriverOpen(false);
            setSidebarAddAssociationsOpen(false);
        }
    }, [sidebarAddVehicleOpen]);

    useEffect(() => {
        if (sidebarAddAssociationsOpen) {
            setSidebarAddServiceOpen(false);
            setSidebarModifyFleetOpen(false);
            setSidebarAddRouteOpen(false);
            setSidebarNotificationsOpen(false);
            setSidebarAddDriverOpen(false);
            setSidebarAddVehicleOpen(false);
        }
    }, [sidebarAddAssociationsOpen]);

    const value: IActionSidebarsContext = useMemo(() => {
        return {
            sidebarAddServiceOpen,
            setSidebarAddServiceOpen,
            sidebarModifyFleetOpen,
            setSidebarModifyFleetOpen,
            sidebarAddRouteOpen,
            setSidebarAddRouteOpen,
            sidebarNotificationsOpen,
            setSidebarNotificationsOpen,
            sidebarAddDriverOpen,
            setSidebarAddDriverOpen,
            sidebarAddVehicleOpen,
            setSidebarAddVehicleOpen,
            sidebarAddAssociationsOpen,
            setSidebarAddAssociationsOpen
        }
    }, [sidebarAddServiceOpen, sidebarModifyFleetOpen, sidebarAddRouteOpen, sidebarNotificationsOpen, sidebarAddDriverOpen, sidebarAddVehicleOpen, sidebarAddAssociationsOpen]);

    return (
        <ActionSidebarsContext.Provider
            value={value}
        >
            {children}
        </ActionSidebarsContext.Provider>
    );
};